import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const sessionExpiredInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      const isSessionCall =
        request.url.startsWith('/api') && !request.url.startsWith('/api/admin/auth/login');
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        isSessionCall &&
        auth.isAuthenticated()
      ) {
        auth.markExpired();
        void router.navigate(['/sessione-scaduta']);
      }
      return throwError(() => error);
    }),
  );
};
